import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';

const Item = ({col, name, description, image, url, subtitle, url_store, price, storeBoxColor, open, open_text, consider_color, image_2}) => {

  // .itemrestaurant:hover{
  // 	border: 1px solid #0166ff;
  // 	cursor:pointer;
  // 	transition-duration: 1s, 2s;
  // }

  const [marginLeftImg, setMarginLeftImg] = useState('0px');

  const useStyles = makeStyles(() => ({
    itemRestaurantBorder: {
      '&:hover': {
        border: '1px solid '+storeBoxColor,
      },
    },
    titleCol: {
      color: storeBoxColor,
    },
    marginLeftImg: {
      margin: '0px',
    }
  }));

  const classes = useStyles();

  const division = `col-lg-${col} p-2 mb-4 zoomuin`;

  return (
    <div className={division}>
      <div className={"rounded-lg bg-white p-0 itemrestaurant " + classes.itemRestaurantBorder}>
        <a href={url}>
          <figure>
            <div className="opacity-img-off">
            {
              console.log(window.innerWidth)
            }
            {/*<img src={(image_2 && window.innerWidth<992) ? image_2 : image} className={"img-autoheight "+(!open ? "img-restaurant-off " : " " + classes.marginLeftImg)} />*/}
            <img src={(image_2 && window.innerWidth<992) ? image_2 : image} className={"img-autoheight "+(!open ? " " + classes.marginLeftImg : " " + classes.marginLeftImg)} />
            </div>
          </figure>
        </a>
        {
          price!==null ?
            <div className="price-square">
              {price}
            </div>
          :
            null
        }
        <div className="p-3">
          {
            consider_color ?
              <p className={"open-text "+(open ? "color-green" : "color-red")}>{open_text}</p>
            :
              <p className="open-text">{open_text}</p>
          }
          <a href={url}>
            <p className={"titlerest " + classes.titleCol}>{name}</p>
          </a>
            {
              subtitle!==null ?
                <a href={url_store}><h6>{subtitle}</h6></a>
              :
                null
            }
            <div className="descrptest" dangerouslySetInnerHTML={{__html: description}} />
        </div>
      </div>
    </div>
  );
}

export default Item;
